module.exports = __webpack_public_path__ + "img/AR.2a99e700.webp";